<template>
  <div class="footer">
    <div class="pc_down">
      <div class="describle">
        <p>
          Second Curve Tech ApS, whose registered address is c/o Nordic Legal
          AdvokatApS, Flæsketorvet 68, 1711 Copenhagen, Denmark, is licensed and
          regulated by the Danish Gambling Authority (Spillemyndigheden).
        </p>
      </div>

      <div class="divide-line" />

      <div class="jump_btn">
        <a href="https://www.spillemyndigheden.dk" target="_blank">
          <img src="/static/img/home/denmark/stop_spillet_Emblem.png" />
        </a>
        <a href="https://www.stopspillet.dk" target="_blank">
          <img src="/static/img/home/denmark/stop_spillet.png" />
        </a>
        <a href="https://www.rofus.nu" target="_blank">
          <img src="/static/img/home/denmark/rufus.png" />
        </a>
        <a>
          <img src="/static/img/home/denmark/18_rating_logo.png" />
        </a>
      </div>

      <div class="wrapper">
        <div class="content" v-if="!hidedata && !isWorldPlatform">
          <a target="_blank" :href="globalConfig.about">{{
            $t("register.LAB_ABOUT")
          }}</a>
          <a target="_blank" :href="globalConfig.privacyPolicy">{{
            $t(globalConfig.LAB_POLICY)
          }}</a>
          <a target="_blank" :href="globalConfig.termsOfService">{{
            $t("register.LAB_TERM")
          }}</a>
        </div>

        <div class="copyright">
          <strong>{{ $t("register.LAB_COPY", { link: currentYear }) }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { worldPlatform } from "../../configs/worldSetting";

export default {
  data() {
    const res = JSON.parse(localStorage.getItem("legal"));
    const isWorldPlatform = worldPlatform.includes(res.platform);

    return {
      isWorldPlatform,
      input: "",
      show: false,
      FB_VERSON: "",
      checked: false,
      subscribe_error: "",
      subscribe_step: 0,
      noticeUrl: `${process.env.VUE_APP_NOTICE_KKPOKER}/mobile/restricted_territory`,
      currentYear: new Date().getFullYear(),
      gliLink: "https://access.gaminglabs.com/Certificate/Index?i=429",
    };
  },
  props: ["hidedata"],
  mounted() {
    let currentType = JSON.parse(localStorage.getItem("legal")).currentType;
    console.log("currentType", currentType);
    this.gliLink =
      currentType === "curacao"
        ? "https://access.gaminglabs.com/Certificate/Index?i=429"
        : "https://access.gaminglabs.com/Certificate/Index?i=372";
    console.log(this.gliLink);
  },
  methods: {
    toBottom() {
      if (
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1
      ) {
        document.querySelector(".footer").scrollIntoView(true);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.desktop {
  .footer {
    width: 19rem;

    .mobile_down {
      display: none;
    }

    .pc_down {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .jump_btn {
      width: 18rem;
      justify-content: space-evenly;
    }
    // .wrapper {
    //   width: 60%;
    // }
    .content {
      gap: 120px;
      a {
        text-decoration: underline !important;
        font-size: 0.27rem;
      }
    }
    .copyright p {
      font-size: 0.27rem;
    }

    .describle {
      p {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 0.3rem;
        line-height: 0.47rem;
        letter-spacing: 0.005rem;
        color: rgba(255, 255, 255, 0.5);

        a {
          font-size: 20px;
          line-height: 36px;
        }
      }

      margin-bottom: 40px;
    }
  }
}

.footer {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  font-size: 24px;
  color: #fff;
  padding: 60px 40px;

  .divide-line {
    width: 100%;
    height: 1px;
    background-color: #444;
  }

  .describle {
    margin: 0 auto 40px;
    p {
      color: #fff;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 0.3rem;
      line-height: 0.47rem;
      letter-spacing: 0.005rem;
    }
  }

  .jump_btn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 50px 0px 40px 0px;
    text-align: center;

    a {
      display: inline-block;
      margin: 0px 10px 25px 10px;
      cursor: pointer;
    }

    img {
      display: inline-block;
      vertical-align: middle;
      height: 80px;
      width: auto;
      // margin: 0px 16px;
    }
  }

  .wrapper {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0 30px;
    background-color: #151515;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content {
    padding: 20px 0px;
    display: flex;
    justify-content: space-evenly;
    gap: 50px;
    margin-right: 0px;

    a {
      color: #ffffff;
      font-size: 24px;
      margin: 10px 0px;
      display: inline-block;
      text-decoration: underline !important;
      // box-shadow: 0 1PX;
    }
  }

  .copyright p {
    color: #8a8a8a;
    font-size: 18px;
  }
}
</style>
